module.exports = __webpack_public_path__ + "static/media/manwithpc2.5d508ebd.svg";